import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IBankBillet from "Types/BankBillet";

export const GET_MEIS = "[MEI] GET_MEIS";
export const GET_MEIS_SUCCESS =
	"[MEI] GET_MEIS_SUCCESS";
export const GET_MEIS_FAILED = "[MEI] GET_MEIS_FAILED";

export const IMPORT_MEIS = "[MEI] IMPORT_MEIS";
export const IMPORT_MEIS_SUCCESS =
	"[MEI] IMPORT_MEIS_SUCCESS";
export const IMPORT_MEIS_FAILED =
	"[MEI] IMPORT_MEIS_FAILED";

export const SET_VALUE = "[MEI EDIT] SET_VALUE";
export const CLEAR_VALUES = "[MEI EDIT] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function importBankBillets(
	data?: any[],
	callback?: Callback<IBankBillet[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: IMPORT_MEIS });

		try {
			const { login } = getState();

			const response = await api.sendPost("/BankBillet/Import", data, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: IMPORT_MEIS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: IMPORT_MEIS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: IMPORT_MEIS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getBankBillets(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<IBankBillet[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_MEIS });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/BankBillet?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_MEIS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_MEIS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_MEIS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
